import { collection, doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export function subscribeAcademyProgress(uid, onData, onError) {
  const col = collection(db, ...FS.academyProgress(appId, uid));
  return onSnapshot(col, (snap) => {
    const map = {};
    snap.docs.forEach((d) => { map[d.id] = d.data()?.completed === true; });
    onData(map);
  }, onError);
}

export async function markLessonComplete(uid, lessonId, lessonTitle) {
  await setDoc(
    doc(db, ...FS.academyProgress(appId, uid), lessonId),
    { completed: true, completedAt: serverTimestamp(), lessonTitle },
    { merge: true },
  );
}
